<template>
	<div>
		<el-dialog class="dialog_Model" :title="region_theme_text + '详情'"  :visible.sync="Model" width="1000px" center>
			<el-form label-width="100px" label-position="reght" class="form-style" v-loading="loading">
				<el-form-item label="编码:" v-if="loginRole != 'staff'">
					{{competition_course.id}}
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('cover') + ':'" v-if="competition_course.cover">
					<img :src="alOssUrl + competition_course.cover" style="width: 100px;height: 100px;margin-top: 10px;" alt=""
						@click="showFile(competition_course.cover)">
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('name') + ':'" v-if="competition_course.name">
					{{competition_course.name}}
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('course_category_id') + ':'" v-if="competition_course.o_course_category">
					<span>
						<span v-if="competition_course.o_course_category.kind == 'labor'">劳动教育-</span>
						<span v-if="competition_course.o_course_category.kind == 'comprehensive'">综合实践-</span>
						<span>{{ competition_course.o_course_category.name }}</span>
					</span>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('competition_course_to_apply') + ':'"
					v-if="competition_course.m_competition_course_to_apply && competition_course.m_competition_course_to_apply.length > 0">
					{{ util.setStage(competition_course.m_competition_course_to_apply) }}
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('hour') + ':'" v-if="competition_course.hour">
					{{competition_course.hour}}
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('course_signature_ids') + ':'"
					v-if="competition_course.m_competition_course_to_course_signature && competition_course.m_competition_course_to_course_signature.length > 0">
					<span v-for="(item, index) in competition_course.m_competition_course_to_course_signature" :key="item.course_signature_id">
						{{ item.o_course_signature && item.o_course_signature.name }}
						<span v-if="index !== competition_course.m_competition_course_to_course_signature.length - 1">，</span>
					</span>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('introduction') + ':'" v-if="competition_course.introduction">
					<div class="description-box">
						<pre>{{competition_course.introduction}}</pre>
					</div>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('author') + ':'" v-if="competition_course.author">
					{{ competition_course.author }}
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('author_recommend') + ':'" v-if="competition_course.author_recommend">
					<div class="description-box">
						<pre>{{competition_course.author_recommend}}</pre>
					</div>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('author_recommend') + '标签:'"
					v-if="competition_course.competition_course_author_recommend_signature && competition_course.competition_course_author_recommend_signature.length > 0">
					<span v-for="(item, index) in competition_course.competition_course_author_recommend_signature" :key="`competition_course_author_recommend_signature_${item.id}`">
						{{ item.name }}
						<span v-if="index !== competition_course.competition_course_author_recommend_signature.length - 1">，</span>
					</span>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('competition_course_videos') + ':'"
					v-if="competition_course_video_group && competition_course_video_group.length > 0">
					<div v-for="item in competition_course_video_group" class="video-form-item">
						<div>{{item.group.name}}</div>
						<div v-if="item.list.length > 0">
							<div v-for="video in item.list" class="video-form-item">
								<video :src="alOssUrl+video.path" controls="controls" class="video-style"></video>
								<span class="comment-default-text-btn" @click="downloadVideoOrAudio(video)">下载</span>
							</div>
						</div>
						<div v-else>
							<span>暂无</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('competition_course_audios') + ':'"
					v-if="competition_course_audio_group && competition_course_audio_group.length > 0">
					<div v-for="item in competition_course_audio_group" class="video-form-item">
						<div>{{item.group.name}}</div>
						<div v-if="item.list.length > 0">
							<div v-for="audio in item.list" class="video-form-item">
								<audio :src="alOssUrl+audio.path" controls="controls" class="audio-style"></audio>
								<!-- <span class="comment-default-text-btn" @click="downloadVideoOrAudio(audio)">下载</span> -->
							</div>
						</div>
						<div v-else>
							<span>暂无</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item :label="util.getKeyFrontValue('competition_course_files') + ':'"
					v-if="competition_course_file_group && competition_course_file_group.length > 0">
					<div v-for="item in competition_course_file_group">
						<div>{{item.group.name}}</div>
						<div v-if="item.list.length > 0" class="my-upload-list">
							<div v-for="file in item.list">
								<div class="upload-flex">
									<img :src="util.setFileIcon(file.path)" class='my-file'>
									<span>{{ file.name.length>25 ? file.name.substr(0, 25)+'...':file.name }}({{file.size}})</span>
								</div>
								<div>
									<span @click='showFile(file.path)' class="show-flie-open">预览</span>
									<span @click='downloadFile(file.path, file.name)' class="show-flie-open">下载</span>
							</div>
							</div>
						</div>
						<div v-else>
							<span>暂无</span>
						</div>
					</div>

					<!-- <div class="my-upload-list">
						<div v-for="item in competition_course_file">
							<div class="upload-flex">
								<img :src="util.setFileIcon(item.path)" class='my-file'>
								<span>{{ item.name.length>25 ? item.name.substr(0, 25)+'...':item.name }}({{item.size}})</span>
							</div>
							<div>
								<span @click='showFile(item.path)' class="show-flie-open">预览</span>
								<span @click='downloadFile(item.path, item.name)' class="show-flie-open">下载</span>
							</div>
						</div>
					</div> -->
				</el-form-item>
				<el-form-item label="姓名:">
					{{competition_course_author.name}}
				</el-form-item>
				<el-form-item label="单位类型:">
					<span v-if="competition_course_author.affiliation_type == 'school'">学校</span>
					<span v-else-if="competition_course_author.affiliation_type == 'practice_base'">基地</span>
					<span v-else-if="competition_course_author.affiliation_type == 'research_institution'">机构</span>
				</el-form-item>
				<el-form-item label="所属单位:">
					{{competition_course_author.o_county ? competition_course_author.o_county.provincial_name : ''}}
					{{competition_course_author.o_county ? competition_course_author.o_county.municipal_name : ''}}
					{{competition_course_author.o_county ? competition_course_author.o_county.county_name : ''}}
					{{competition_course_author.affiliation}}
				</el-form-item>
				<el-form-item label="收货地址:">
					{{competition_course_author.address}}
				</el-form-item>
				<el-form-item label="状态:" v-if="loginRole == 'government'">
					<span v-if="listInfo.confirm_status == util.case_confirm_status['waiting_confirm'].code">待审核</span>
					<span v-if="listInfo.confirm_status == util.case_confirm_status['fail'].code">未通过</span>
					<span v-if="listInfo.confirm_status == util.case_confirm_status['success'].code">已通过</span>
				</el-form-item>
				<el-form-item label="得分:" v-if="rate != null">
						{{rate}}
				</el-form-item>
				<el-form-item style="margin-top: 40px;" label="">
					<button type="button" class="cancel-btn" @click="hide">关闭</button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<showFile ref='show'></showFile>
	</div>
</template>

<script>
	import showFile from './showFile.vue'
	export default {
		components: {
			showFile
		},
		data() {
			return {
				loginRole: sessionStorage.getItem('loginRole'),
				region_theme_text: JSON.parse(sessionStorage.getItem('region_theme_text')) ? JSON.parse(sessionStorage.getItem('region_theme_text')) : '课程',
				loading: false,
				Model: false,
				listInfo: {},
				// 课程基本信息
				competition_course: {},
				// 课程音频
				competition_course_audio_group: [],
				// 课程视频
				competition_course_video_group: [],
				// 作者信息
				competition_course_author: {},
				// 附件
				competition_course_file_group: [],
				rate: null,

			}
		},
		methods: {
			hide() {
				this.Model = false
				this.listInfo = {},
				// 课程基本信息
				this.competition_course = {},
				// 课程音频
				this.competition_course_audio_group = [],
				// 课程视频
				this.competition_course_video_group = [],
				// 作者信息
				this.competition_course_author = {},
				// 附件
				this.competition_course_file_group = []
			},
			show(row) {
				this.listInfo = row
				this.Model = true
				this.getCourseDetail()
			},
			// 文件预览
			showFile(url) {
				this.$refs.show.preview(url)
			},
			// 视频下载
			downloadVideoOrAudio(item) {
				this.$message.success('开始下载，请耐心等待!')
				const videoUrl = this.alOssUrl + item.path
				fetch(videoUrl).then((res) => {
				  res.blob().then((blob) => {
				    const blobUrl = window.URL.createObjectURL(blob);
				    const filename = item.name;
				    const a = document.createElement('a');
				    a.href = blobUrl;
				    a.download = filename;;
				    a.click();
				    window.URL.revokeObjectURL(blobUrl);
				  });
				});
			},
			// 附件下载
			downloadFile(path, name) {
				const a = document.createElement('a')
				a.setAttribute('download',(name+'').trim())
				a.setAttribute('target', '_blank')
				a.setAttribute('href', this.alOssUrl + path)
				a.click()
			},
			getCourseDetail() {
				this.loading = true
				this.HttpUtil.Get(this.api.util.competitionCourseDetail, {
					id: this.listInfo.id
				}).then((res) => {
					this.competition_course = res.competition_course
					this.competition_course_author = res.competition_course?.o_competition_course_author || {}

					this.competition_course_file_group = []
					res.competition_course_file_group.forEach(item => {
						this.competition_course_file_group.push({
							group: {
								name: item.name,
								id: item.id,
							},
							list: []
						})
						res.competition_course_file.forEach(file => {
							if(file.competition_course_file_group_id == item.id) {
								this.competition_course_file_group[this.competition_course_file_group.length - 1].list.push(file)
							}
						})
					})

					this.competition_course_video_group = []
					res.competition_course_video_group.forEach(item => {
						this.competition_course_video_group.push({
							group: {
								name: item.name,
								id: item.id,
							},
							list: []
						})
						res.competition_course_video.forEach(video => {
							if(video.competition_course_video_group_id == item.id) {
								this.competition_course_video_group[this.competition_course_video_group.length - 1].list.push(video)
							}
						})
					})

					this.competition_course_audio_group = []
					res.competition_course_audio_group.forEach(item => {
						this.competition_course_audio_group.push({
							group: {
								name: item.name,
								id: item.id,
							},
							list: []
						})
						res.competition_course_audio.forEach(audio => {
							if(audio.competition_course_audio_group_id == item.id) {
								this.competition_course_audio_group[this.competition_course_audio_group.length - 1].list.push(audio)
							}
						})
					})
					if (res.competition_course?.o_competition_course_rate?.rate) {
						this.rate = res.competition_course.o_competition_course_rate.rate / 10;
					}
					this.loading = false;
				})
			},
		},
		mounted() {
			
		}
	}
</script>

<style scoped>
	.dialog_Model /deep/ .el-dialog--center .el-dialog__body {
		padding: 20px 20px 30px !important;
		max-height: 70vh !important;
		overflow-y: auto;
	}
	.form-style {
		padding: 0 20px;
	}
	.form-style .el-form-item {
		/* line-height: 21px !important; */
		margin-bottom: 0px;
		color: #333333;
	}
	.description-box {
		margin-top: 10px;
		line-height: 21px;
	}
	.description-box pre {
		font-family: "Microsoft YaHei";
		white-space: pre-wrap;
		word-wrap: break-word;
	}
	.comment-default-text-btn {
		color: #1FB3F7 ;
		font-size: 14px;
		cursor: pointer;
	}
	.video-style {
		object-fit:contain;
		width: 355px;
		height: 182px;
		border-radius: 5px;
		margin-right: 20px;
	}
	.audio-style {
		margin-right: 20px;
	}
</style>
